<template>
    <div class="dashboard-global-preparation-priority h-100 text-center">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors">
            <div class="d-flex flex-row dashboard-row">
                <div class="row no-gutters flex-fill">
                    <div class="col p-3 border border-black text-white">
                        <div class="h1 mb-0">
                            {{ todayHumanDate }}
                            <small>{{ currentHumanHour }}</small>
                        </div>
                        <div class="h3 mb-0 mt-1">
                            Préparation par priorité
                        </div>
                    </div>
                    <DashboardOrderBox
                        v-for="(name, key) in ['pickup_points_productions', 'pickup_points_subcustomers', 'short_channels', 'customer_groups', 'stores']"
                        :name="nameFromProgressCounterKey(name)"
                        :key="key"
                        :id="key"
                        :preparation-status="progressCounters[name]"
                        box-class="col"
                    />
                </div>
            </div>
            <alerts type="dashboards"></alerts>
            <div class="d-flex flex-row dashboard-row" v-if="mainCategories && mainCategories.length > 0">
                <div class="row no-gutters flex-fill">
                    <DashboardOrderBox
                        v-for="mainCategory in mainCategories"
                        v-if="mainCategory.category.id"
                        :key="mainCategory.category.id"
                        :id="mainCategory.category.id"
                        :name="mainCategory.category.name"
                        :preparation-status="mainCategory.preparation_status"
                        box-class="col-3"
                    />
                </div>
            </div>
            <div class="d-flex flex-row dashboard-row" v-if="pickupPointsAllOrders.length !== 0">
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-left h5">
                        Production des lieux de retrait
                    </div>
                </div>
                <div class="row no-gutters flex-fill">
                    <template v-for="pickupPoint in _.orderBy(pickupPointsAllOrders, ['name'])">
                        <DashboardOrderBox
                            v-if="pickupPoint.order && pickupPoint.order.id && pickupPoint.order.is_production_preparable"
                            :key="pickupPoint.order.id"
                            :id="pickupPoint.order.id"
                            :name="pickupPoint.order.name"
                            :type="pickupPoint.order.type"
                            :online="pickupPoint.order.online === 1"
                            :preparation-status="pickupPoint.order.preparation_status"
                            box-class="col-2" />
                    </template>
                </div>
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-right">
                        Production des lieux de retrait
                    </div>
                </div>
            </div>
            <div class="d-flex flex-row dashboard-row">
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-left h5">
                        Avant 16h
                    </div>
                </div>
                <div class="row no-gutters flex-fill">
                    <template v-if="_.values(pickupPointsAllOrders).length !== 0">
                        <template v-for="pickupPoint in _.orderBy(_.values(pickupPointsAllOrders), ['name'])"
                                  v-if="pickupPoint.subcustomers_orders.online.length !== 0 || pickupPoint.subcustomers_orders.internal.length !== 0">
                            <template v-if="pickupPoint.subcustomers_orders.online.length !== 0">
                                <DashboardOrderBox
                                    v-for="order in pickupPoint.subcustomers_orders.online"
                                    v-if="order.id && !order.is_done && order.has_priority"
                                    :key="order.id"
                                    :id="order.id"
                                    :name="order.name"
                                    :type="order.type"
                                    :online="order.online === 1"
                                    :preparation-status="order.preparation_status"
                                    box-class="col-2" />
                            </template>
                            <template v-if="pickupPoint.subcustomers_orders.internal.length !== 0">
                                <DashboardOrderBox
                                    v-for="order in pickupPoint.subcustomers_orders.internal"
                                    v-if="order.id && !order.is_done && order.has_priority"
                                    :key="order.id"
                                    :id="order.id"
                                    :name="order.name"
                                    :type="order.type"
                                    :online="order.online === 1"
                                    :preparation-status="order.preparation_status"
                                    box-class="col-2" />
                            </template>
                        </template>
                    </template>
                    <template v-if="shortChannelsOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(shortChannelsOrders, ['short_channel_name'])"
                            v-if="order.id && !order.is_done && order.has_priority"
                            :key="order.id"
                            :id="order.id"
                            :name="order.short_channel_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2" />
                    </template>
                    <template v-if="customerGroupsOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(customerGroupsOrders, ['customer_group_name'])"
                            v-if="order.id && !order.is_done && order.has_priority"
                            :key="order.id"
                            :id="order.id"
                            :name="order.customer_group_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2"/>
                    </template>
                    <template v-if="storesOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(storesOrders, ['store_name'])"
                            v-if="order.id && !order.is_done && order.has_priority"
                            :key="order.id"
                            :id="order.id"
                            :name="order.store_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2" />
                    </template>
                </div>
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-right">
                        Avant 16h
                    </div>
                </div>
            </div>
            <div class="d-flex flex-row dashboard-row">
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-left h5">
                        Après 16h
                    </div>
                </div>
                <div class="row no-gutters flex-fill">
                    <template v-if="_.values(pickupPointsAllOrders).length !== 0">
                        <template v-for="pickupPoint in _.orderBy(_.values(pickupPointsAllOrders), ['name'])"
                                  v-if="pickupPoint.subcustomers_orders.online.length !== 0 || pickupPoint.subcustomers_orders.internal.length !== 0">
                            <template v-if="pickupPoint.subcustomers_orders.online.length !== 0">
                                <DashboardOrderBox
                                    v-for="order in pickupPoint.subcustomers_orders.online"
                                    v-if="order.id && !order.is_done && !order.has_priority"
                                    :key="order.id"
                                    :id="order.id"
                                    :name="order.name"
                                    :type="order.type"
                                    :online="order.online === 1"
                                    :preparation-status="order.preparation_status"
                                    box-class="col-2" />
                            </template>
                            <template v-if="pickupPoint.subcustomers_orders.internal.length !== 0">
                                <DashboardOrderBox
                                    v-for="order in pickupPoint.subcustomers_orders.internal"
                                    v-if="order.id && !order.is_done && !order.has_priority"
                                    :key="order.id"
                                    :id="order.id"
                                    :name="order.name"
                                    :type="order.type"
                                    :online="order.online === 1"
                                    :preparation-status="order.preparation_status"
                                    box-class="col-2" />
                            </template>
                        </template>
                    </template>
                    <template v-if="shortChannelsOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(shortChannelsOrders, ['short_channel_name'])"
                            v-if="order.id && !order.is_done && !order.has_priority"
                            :key="order.id"
                            :id="order.id"
                            :name="order.short_channel_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2" />
                    </template>
                    <template v-if="customerGroupsOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(customerGroupsOrders, ['customer_group_name'])"
                            v-if="order.id && !order.is_done && !order.has_priority"
                            :key="order.id"
                            :id="order.id"
                            :name="order.customer_group_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2"/>
                    </template>
                    <template v-if="storesOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(storesOrders, ['store_name'])"
                            v-if="order.id && !order.is_done && !order.has_priority"
                            :key="order.id"
                            :id="order.id"
                            :name="order.store_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2" />
                    </template>
                </div>
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-right">
                        Après 16h
                    </div>
                </div>
            </div>
            <div class="d-flex flex-row dashboard-row">
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-left h5">
                        Prêtes / Distribuées
                    </div>
                </div>
                <div class="row no-gutters flex-fill">
                    <template v-if="_.values(pickupPointsAllOrders).length !== 0">
                        <template v-for="pickupPoint in _.orderBy(_.values(pickupPointsAllOrders), ['name'])"
                                  v-if="pickupPoint.subcustomers_orders.online.length !== 0 || pickupPoint.subcustomers_orders.internal.length !== 0">
                            <template v-if="pickupPoint.subcustomers_orders.online.length !== 0">
                                <DashboardOrderBox
                                    v-for="order in pickupPoint.subcustomers_orders.online"
                                    v-if="order.id && order.is_done"
                                    :key="order.id"
                                    :id="order.id"
                                    :name="order.name"
                                    :type="order.type"
                                    :online="order.online === 1"
                                    :preparation-status="order.preparation_status"
                                    box-class="col-2" />
                            </template>
                            <template v-if="pickupPoint.subcustomers_orders.internal.length !== 0">
                                <DashboardOrderBox
                                    v-for="order in pickupPoint.subcustomers_orders.internal"
                                    v-if="order.id && order.is_done"
                                    :key="order.id"
                                    :id="order.id"
                                    :name="order.name"
                                    :type="order.type"
                                    :online="order.online === 1"
                                    :preparation-status="order.preparation_status"
                                    box-class="col-2" />
                            </template>
                        </template>
                    </template>
                    <template v-if="shortChannelsOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(shortChannelsOrders, ['short_channel_name'])"
                            v-if="order.id && order.is_done"
                            :key="order.id"
                            :id="order.id"
                            :name="order.short_channel_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2" />
                    </template>
                    <template v-if="customerGroupsOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(customerGroupsOrders, ['customer_group_name'])"
                            v-if="order.id && order.is_done"
                            :key="order.id"
                            :id="order.id"
                            :name="order.customer_group_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2"/>
                    </template>
                    <template v-if="storesOrders.length !== 0">
                        <DashboardOrderBox
                            v-for="order in _.orderBy(storesOrders, ['store_name'])"
                            v-if="order.id && order.is_done"
                            :key="order.id"
                            :id="order.id"
                            :name="order.store_name"
                            :type="order.type"
                            :online="order.online === 1"
                            :preparation-status="order.preparation_status"
                            box-class="col-2" />
                    </template>
                </div>
                <div class="sidebars text-white border border-black flex-shrink-0">
                    <div class="rotate rotate-right">
                        Prêtes / Distribuées
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "../../ErrorsZone";
    import LoadingScreen from "../../LoadingScreen";
    import DashboardOrderBox from "./DashboardOrderBox";
    import {useGetLoader} from "../../compositions/axios/loadingRequest";
    import {moment, momentDay} from "../../../moment-with-helpers";
    import {preparationBgClass} from "../../../preparation-classes";

    export default {
        name: "DashboardGlobalPreparationPriority",

        components: {
            ErrorsZone,
            LoadingScreen,
            DashboardOrderBox,
        },

        props: {
            screenUid: {
                type: String,
                required: true,
            },
            screen: {
                type: Object,
                required: false,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                currentHumanHour: '',
                mainCategories: [],
                storesOrders: [],
                shortChannelsOrders: [],
                customerGroupsOrders: [],
                pickupPointsAllOrders: [],
                loadedOnce: false,

                progressCounters: {},
            };
        },

        created() {
            Echo.channel(`dashboards`).listen('OrderUpdatedEvent', (e) => {
                this.loadStateFromServer();
            });
        },

        async mounted() {
            this.updateCurrentHumanHour()
            setInterval(this.updateCurrentHumanHour.bind(this) , 1000)

            await this.loadStateFromServer();
        },

        computed: {
            preparationBgClass,

            todayJsDate() {
                return momentDay()
            },
            todayDate() {
                return this.todayJsDate.format('YYYY-MM-DD')
            },
            todayHumanDate() {
                return this.todayJsDate.format('dddd Do MMMM')
            },
        },

        methods: {
            updateCurrentHumanHour: function() {
                this.currentHumanHour = moment().format('HH:mm:ss')
            },
            loadStateFromServer: async function () {
                const data = await this.load(`/dashboards/preparation/${this.todayDate}/json`);
                if (data) {
                    this.mainCategories = data.mainCategories;
                    this.storesOrders = data.storesOrders;
                    this.shortChannelsOrders = data.shortChannelsOrders;
                    this.customerGroupsOrders = data.customerGroupsOrders;
                    this.pickupPointsAllOrders = data.pickupPointsAllOrders;
                    this.progressCounters = data.progressCounters;

                    this.loadedOnce = true;
                }
            },
            nameFromProgressCounterKey: function (key) {
                let name = 'Inconnu';
                if (key === 'pickup_points_productions') {
                    name = 'Production lieux de retrait';
                } else if (key === 'pickup_points_subcustomers') {
                    name = 'Clients lieux de retrait';
                } else if (key === 'short_channels') {
                    name = 'Circuits courts';
                } else if (key === 'customer_groups') {
                    name = 'Groupements de clients';
                } else if (key === 'stores') {
                    name = 'Magasins';
                }
                return name;

            }
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-global-preparation-priority {
        background-color: #343a40;

        .dashboard-row {
            background-color: #343a40;
            border-bottom: 4px solid #000;
            min-height: 110px;
        }

        .sidebars {
            width: 70px;
            position: relative;
            line-height: 1;
            .rotate {
                font-size: 1.125rem;
                line-height: 1;
            }
        }
    }
</style>
